import momentTimezone from 'moment-timezone';
import { isEmpty } from 'lodash';
import Cookies from 'universal-cookie';

const getScheduleDetailResponse = (response) => {
  if (isEmpty(response?.schedules)) return [];

  const cookies = new Cookies();
  const timezone = cookies.get('organization')?.timezone;

  const startDate = response?.schedules[0]?.details?.[0]?.startedAt;
  const endDate = response?.schedules[0]?.details?.[0]?.endedAt;
  const startTime = momentTimezone.tz(startDate, timezone).format('HH:mm');
  const endTime = momentTimezone.tz(endDate, timezone).format('HH:mm');

  const schedules = response?.schedules?.map((item) => {
    return {
      ...item,
      isOpen: true,
      details: item?.details?.map((detail) => {
        return {
          brandName: item?.brandName,
          id: detail?.id,
          title: detail?.title,
          studio: {
            studio: detail?.studio?.name,
            room: detail?.studio?.room,
            area: detail?.studio?.area,
          },
          startDate: detail?.startedAt,
          endDate: detail?.endedAt,
          accountLivestreams: detail?.accountLivestreams,
          hosts: detail?.hosts
            ?.filter((host) => host?.isActive)
            .map((host) => host.name)
            ?.join(' | '),
          operators: detail?.operators?.map((operator) => operator.name)?.join(' | '),
          rawData: detail,
        };
      }),
    };
  });

  return {
    timeText: `${startTime} - ${endTime}`,
    date: momentTimezone.tz(startDate, timezone).format('dddd, DD MMMM YYYY'),
    schedules,
  };
};

export default getScheduleDetailResponse;
